import { IMandatoryCategory } from '../../../APIPackage/CatalogsModule/interfaces/IMandatoryCategory';
import { IMandatoryCategorySelectOption } from '../interfaces/IMandatoryCategorySelectOption';

export function createMandatoryCategorySelectOption(
  mandatoryCategory: IMandatoryCategory,
): IMandatoryCategorySelectOption {
  return {
    ...mandatoryCategory,
    label: mandatoryCategory.name,
    value: mandatoryCategory.id,
  };
}
